import React, { ReactNode, useState, useEffect } from 'react';
import { X } from 'lucide-react';
import popupR65 from '../assets/images/r65-character.png';

interface TcPopupR65Props {
    hasCloseButton?: boolean;
    classNameStyle?: string;
    handleClose?: () => void;
    children?: ReactNode;
}

const TcPopupR65 = ({ 
    hasCloseButton = true, 
    classNameStyle = "", 
    handleClose = () => {},
    children = null
}: TcPopupR65Props) => {
    const [showWhiteBox, setShowWhiteBox] = useState(false);

    useEffect(() => {
        // Show white box 1 second after component mounts
        const timer = setTimeout(() => {
            setShowWhiteBox(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div id="popup-r65" className={`popupR65 fixed -bottom-9 left-0 right-0 z-[100] ${classNameStyle}`}>
            <div className={`
                relative pl-[5vw] mb-0 
                border border-transparent
                min-h-10 
                max-w-[340px] 2xs:max-w-full xs:max-w-full sm:max-w-[340px] md:max-w-[340px] 
            `}>
                
                {/* Dynamic content panel */}
                <div className={`
                    relative 
                    ml-auto 
                    mr-[5vw] 
                    mb-[150px] 
                    min-w-60 
                    max-w-md 
                    min-h-16 
                    max-h-[50vh] 
                    bg-white/70 backdrop-blur-xl
                    border border-white/40
                    rounded-2xl 
                    overflow-y-auto
                    scrollbar-black
                    transition-all duration-500 ease-out
                    ${showWhiteBox ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
                `}>
                    <div className="relative top-0 right-0 bottom-0 left-0 p-6 max-h-full ">
                        <div className="relative font-medium text-neutral-950">
                            {children}
                        </div>
                    </div>

                    {hasCloseButton &&
                        <button
                            className="absolute top-1 right-1 p-[2px] text-neutral-950 bg-transparent border border-neutral-950 rounded-full z-10 transition-colors"
                            onClick={handleClose}
                            aria-label="Close"
                        >
                            <X size={16} />
                        </button>}
                </div>

                <div className="absolute bottom-0 right-[3vw] w-40 h-40 animate-slide-up">
                    <img src={popupR65} alt="Session Timeout" className="mx-auto" />
                </div>
                
            </div>
        </div>
    )
}

export default TcPopupR65;